
import _ from "@lodash";
import { AppBar, TextField, DialogActions, DialogContent, IconButton, Tab, Tabs, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import FormularioApp from "app/Core/Components/Formulario/FormularioApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import { MdAdd, MdClose, MdRemove } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Planos from "app/Planos/index.json";
import * as Helpers from "app/Core/Helpers";
import XAPPButton from "../../Core/Components/Button/XAPPButton";
import LogRegistro from "../../Core/Components/LogRegistro/LogRegistroApp";
import ArquivoApp from "../../GED/Arquivo/ArquivoApp";
import EmpresaPessoaExcecaoJornadaApp from "../EmpresaPessoaExcecaoJornada/EmpresaPessoaExcecaoJornadaApp";
import EmpresaPessoaFolgaApp from "../EmpresaPessoaFolga/EmpresaPessoaFolgaApp";
import EmpresaPessoaFormularioApp from "../EmpresaPessoaFormulario/EmpresaPessoaFormularioApp";
import EmpresaPessoaJornadaApp from "../EmpresaPessoaJornada/EmpresaPessoaJornadaApp";
import EmpresaPessoaProduto from "../EmpresaPessoaProduto/EmpresaPessoaProduto";
import EmpresaPessoaPermissao from "./Components/EmpresaPessoaPermissao";
import EmpresaPessoaVincularDialog from "./Components/EmpresaPessoaVincularDialog";
import * as Actions from "./Store/Actions/EmpresaPessoaActions";
import React from "react";
import { FuseAnimate } from "@fuse";
import CustomFields from "app/Core/Components/CustomFields/CustomFields";
import GaleriaApp from "app/GED/Galeria/GaleriaApp";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    paper: {
        border: "1px solid " + theme.palette.divider,
        //marginBottom: "24px",
        padding: "4px"
    },
    spanlabel: {
        top: 9,
        left: 15,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
        color: theme.palette.text.secondary,
        maxWidth: "40px",
    }
});

const newPessoaState = {
    tabValue: 0,
    idpessoaformulario: null,
    idpessoa: null,
    tipo: 117,
    formulario: {},
    requeridos: null,
};

class EmpresaPessoaDialog extends XAPPComponent {

    state = { ...newPessoaState };

    componentDidMount() {
        if (_.isUndefined(this.props.template) || _.isNull(this.props.template)) {
            this.props.getTemplate();
        }
        if (_.isUndefined(this.props.tipos) || _.isNull(this.props.tipos)) {
            this.props.getPessoaTipo();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { xappRouteParams, defaultTipo = null } = this.props;

        if (this.props.formDialog.props.error) {
            this.props.showMessage({
                message: this.props.formDialog.props.error,
                variant: "error"
            });
            this.props.formDialog.props.error = null;
        }
        if (this.props.formDialog.props.warning) {
            this.props.showMessage({
                message: this.props.formDialog.props.warning,
                variant: "warning"
            });
            this.props.formDialog.props.warning = null;
        }
        if (this.props.formDialog.props.info) {
            this.props.showMessage({
                message: this.props.formDialog.props.info,
                variant: "success"
            });
            this.props.formDialog.props.info = null;
        }

        if (!_.isUndefined(this.props.formDialog.props.id) && !_.isNull(this.props.formDialog.props.id) &&
            !_.isEqual(prevProps.formDialog.props.id, this.props.formDialog.props.id) &&
            (_.isUndefined(this.state.idpessoaformulario) || _.isNull(this.state.idpessoaformulario))) {
            this.setState({ idpessoaformulario: this.props.formDialog.props.id });
        }

        if (!prevProps.formDialog.props.open && this.props.formDialog.props.open) {
            var obj = { ...newPessoaState };
            obj.idpessoa = xappRouteParams.empresa;
            if (!_.isNull(defaultTipo)) {
                obj.formulario.tipo = defaultTipo;
            }
            if (this.props.formDialog.type === "edit" &&
                this.props.formDialog.data &&
                !_.isEqual(this.props.formDialog.data, prevState)) {
                obj.idpessoaformulario = this.props.formDialog.data.idpessoaformulario;
                obj.idpessoa = this.props.formDialog.data.formulario.idpessoa;
                obj.statusregistro = this.props.formDialog.data.statusregistro;
                obj.formulario = { ...this.props.formDialog.data.formulario };
            }
            this.setState(obj);
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
    };

    handleChangeFormulario = (_AForm) => {
        this.setState({ "formulario": _AForm });
    };

    setRequeridos = (_ARequeridos) => {
        this.setState(_.set({ ...this.state }, "requeridos", _ARequeridos));
    };

    canBeSubmitted = () => {
        const { requeridos, formulario } = this.state;
        if ((Object.keys(formulario).length < 1) || (requeridos === null)) {
            return false;
        }
        var AResponse = true;
        Object.keys(requeridos).forEach(key => {
            if (AResponse && requeridos[key] &&
                (_.isUndefined(formulario[key]) || _.isNull(formulario[key]) || formulario[key].length < 1)) {
                AResponse = false;
            }
        });

        return AResponse;
    };

    handleChangeTab = (event, tabValue) => {
        this.setState({ tabValue });
    };

    handleChangeConfig = (event, index) => {
        let obj = Object.assign({}, this.state.formulario);
        obj.configuracao[index][event.target.name] = event.target.value;
        this.setState(_.set({ ...this.state }, "formulario", obj));
    };

    toogleConfig = (_AOperacao = "mais") => {
        let obj = Object.assign({}, this.state.formulario);
        if (_.isUndefined(obj.configuracao) || _.isNull(obj.configuracao) || obj.configuracao === "") {
            obj.configuracao = [];
        }

        if (_AOperacao === "mais") {
            obj.configuracao.push({ "chave": "", "valor": "" });
        }
        else {
            obj.configuracao.pop();
        }
        this.setState(_.set({ ...this.state }, "formulario", obj));
    };

    handleChangePropForm = (event) => {
        this.setState({ "formulario": _.set({ ...this.state.formulario }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value) });
    };

    get = (_AID) => {
        const { get, xappRouteParams, closeDialog } = this.props;
        closeDialog();
        setTimeout(() => get(_AID, xappRouteParams), 1000);
    };

    render() {
        const { formDialog, id, save, settings, target, isButton, closeDialog, callback, xappRouteParams, customTags, disablePersonFields = false, template, customFields, tipos, acaoRegistro, isGestor = false, TagsPessoa } = this.props;
        const form = this.state;

        var AIsFuncionario = !_.isUndefined(form.formulario.tipo) && !_.isNull(form.formulario.tipo) && form.formulario.tipo.includes(1);
        var AIsProfissional = !_.isUndefined(form.formulario.tipo) && !_.isNull(form.formulario.tipo) && form.formulario.tipo.includes(2);
        return (
            <XAPPDialog
                {...formDialog.props}
                onClose={closeDialog}
                fullWidth
                fullScreen
                id={id}
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {formDialog.type === "new" ? "Novo registro" : "Editar registro"}
                        </Typography>
                        {formDialog.data && (
                            <LogRegistro
                                primaryKey={"idpessoaformulario"}
                                Log={formDialog.data}
                            />
                        )}
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={closeDialog}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <DialogContent className="p-0">
                    <Tabs
                        value={form.tabValue}
                        onChange={this.handleChangeTab}
                        indicatorColor="secondary"
                        textColor="secondary"
                        variant="scrollable"
                        scrollButtons="auto"
                        classes={{ root: "w-full h-32" }}
                    >
                        <Tab value={0} className="h-32 normal-case" label="Detalhes" />
                        {!_.isNull(form.idpessoaformulario) && Helpers.checkPlano(Planos.arquivos.show, settings) &&
                            <Tab value={1} className="h-32 normal-case" label="Arquivos" />
                        }
                        {!_.isNull(form.idpessoaformulario) && disablePersonFields && Helpers.checkPlano(Planos.arquivos.show, settings) &&
                            <Tab value={9} className="h-32 normal-case" label="Galeria" />
                        }
                        {!_.isNull(form.idpessoaformulario) && !disablePersonFields &&
                            <Tab value={2} className="h-32 normal-case" label="Documentos" />
                        }
                        {!_.isNull(form.idpessoaformulario) && form.formulario.natureza === "1" && isGestor && !disablePersonFields &&
                            <Tab value={3} className="h-32 normal-case" label="Permissões" />
                        }
                        {!_.isNull(form.idpessoaformulario) && AIsProfissional &&
                            <Tab value={4} className="h-32 normal-case" label="Serviços" />
                        }
                        {!_.isNull(form.idpessoaformulario) && AIsFuncionario && !disablePersonFields && Helpers.checkPlano(Planos.agendamento.consistencia, settings) &&
                            <Tab value={5} className="h-32 normal-case" label="Jornada de trabalho" />
                        }
                        {/* {AIsFuncionario && !disablePersonFields && Helpers.checkPlano(Planos.agendamento.consistencia, settings) &&
                            <Tab value={6} className="h-32 normal-case" label="Folgas" />
                        } */}
                        {/* {AIsFuncionario && !disablePersonFields && Helpers.checkPlano(Planos.agendamento.consistencia, settings) &&
                            <Tab value={7} className="h-32 normal-case" label="Exceções de jornada" />
                        } */}
                        {!_.isNull(form.idpessoaformulario) && AIsFuncionario && !disablePersonFields && Helpers.checkPlano(Planos.agendamento.consistencia, settings) &&
                            <Tab value={8} className="h-32 normal-case" label="Configurações" />
                        }
                    </Tabs>
                    {form.tabValue === 0 &&
                        <div className="p-24">
                            {template !== undefined && template !== null &&
                                <FormularioApp
                                    Formulario={template}
                                    onChange={this.handleChangeFormulario}
                                    customProps={{
                                        "natureza": { show: (form.idpessoaformulario === null && !disablePersonFields) },
                                        "origem": { show: !disablePersonFields },
                                        "sexo": { show: !disablePersonFields },
                                        "nascimentoabertura": { show: !disablePersonFields },
                                        "obito": { show: !disablePersonFields },
                                        "nome": { show: true, target: target, onSelected: this.get },
                                        "nomesocial": { show: !disablePersonFields },
                                        "contatos": { show: !disablePersonFields },
                                        "dadosadicionais": { show: !disablePersonFields },
                                        "enderecoresidencial": { show: true },
                                        "enderecocomercial": { show: !disablePersonFields },
                                        "alergias": { show: ["200"].includes(settings.tipo) },
                                        "tags": { "show": (form.idpessoaformulario !== null), "data": TagsPessoa, "callback": callback, "tipo": customTags, "foreingkey": form.idpessoaformulario },
                                        "centrocusto": { "show": AIsProfissional },
                                        "atendimentoonline": { "show": AIsProfissional },
                                    }}
                                    setRequeridos={this.setRequeridos}
                                    data={form.formulario}
                                    xappRouteParams={xappRouteParams}
                                    isGestor={isGestor}
                                />
                            }
                            <CustomFields
                                xappRouteParams={xappRouteParams}
                                tipo={customFields}
                                formulario={form.formulario}
                                onChange={this.handleChangePropForm}
                            />
                        </div>
                    }
                    {form.tabValue === 1 &&
                        <div className="px-12">
                            <ArquivoApp
                                xappRouteParams={xappRouteParams}
                                idfuncionalidade={form.idpessoaformulario}
                                campofuncionalidade={"idpessoaformulario"}
                                tipo={1}
                                showRemover={true}
                            //showListagem={false}
                            />
                        </div>
                    }
                    {form.tabValue === 2 &&
                        <div className="px-12">
                            <EmpresaPessoaFormularioApp
                                xappRouteParams={xappRouteParams}
                                idparent={form.idpessoaformulario}
                            />
                        </div>
                    }
                    {form.tabValue === 3 &&
                        <div className="px-12">
                            <EmpresaPessoaPermissao
                                xappRouteParams={xappRouteParams}
                                formulario={form.formulario}
                                handleChange={this.handleChange}
                                tipos={tipos}
                            />
                        </div>
                    }
                    {form.tabValue === 4 &&
                        <div className="px-12">
                            <EmpresaPessoaProduto
                                xappRouteParams={xappRouteParams}
                                idparent={form.idpessoaformulario}
                                tipo="pessoa"
                                disablePersonFields={disablePersonFields}
                            />
                        </div>
                    }
                    {form.tabValue === 5 &&
                        <div className="px-12">
                            <EmpresaPessoaJornadaApp
                                xappRouteParams={xappRouteParams}
                                idparent={form.idpessoaformulario}
                            />
                        </div>
                    }
                    {form.tabValue === 6 &&
                        <div className="px-12">
                            <EmpresaPessoaFolgaApp
                                xappRouteParams={xappRouteParams}
                                idparent={form.idpessoaformulario}
                            />
                        </div>
                    }
                    {form.tabValue === 7 &&
                        <div className="px-12">
                            <EmpresaPessoaExcecaoJornadaApp
                                xappRouteParams={xappRouteParams}
                                idparent={form.idpessoaformulario}
                            />
                        </div>
                    }
                    {form.tabValue === 8 &&
                        <div className="flex px-12 items-center flex-col">
                            <div className="flex mt-8 lg:w-1/2 w-full" >
                                <IconButton onClick={() => this.toogleConfig("mais")}>
                                    <MdAdd color="action" />
                                </IconButton>
                                <IconButton onClick={() => this.toogleConfig("menos")}>
                                    <MdRemove color="action" />
                                </IconButton>
                            </div>
                            <div className="flex flex-col mt-8 lg:w-1/2 w-full" >
                                {!_.isUndefined(form.formulario.configuracao) && form.formulario.configuracao.length > 0 ?
                                    form.formulario.configuracao.map((item, index) => (
                                        <div key={index} className="flex w-full flex-wrap sm:flex-no-wrap">
                                            <TextField
                                                className="mb-12 w-full sm:w-1/2 sm:mr-8"
                                                label={"Chave"}
                                                id="chave"
                                                name="chave"
                                                value={item.chave}
                                                onChange={ev => this.handleChangeConfig(ev, index)}
                                                variant="outlined"
                                                fullWidth
                                                required
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mb-12 w-full sm:w-1/2"
                                                label={"Valor"}
                                                id="valor"
                                                name="valor"
                                                value={item.valor}
                                                onChange={ev => this.handleChangeConfig(ev, index)}
                                                variant="outlined"
                                                fullWidth
                                                required
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    ))
                                    :
                                    <div className="flex flex-col flex-1 items-center justify-center p-16">
                                        <div className="max-w-512 text-center">
                                            <FuseAnimate delay={500}>
                                                <Typography variant="h6" color="textSecondary" className="mb-16">
                                                    {"Nenhuma configuração adicional encontrada"}
                                                </Typography>
                                            </FuseAnimate>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    {form.tabValue === 9 &&
                        <div className="px-12">
                            <GaleriaApp
                                xappRouteParams={xappRouteParams}
                                idfuncionalidade={form.idpessoaformulario}
                                campofuncionalidade={"idpessoaformulario"}
                                tipo={1}
                                slideAll={true}
                            />
                        </div>
                    }
                </DialogContent>
                {[0, 3, 8].includes(form.tabValue) &&
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions>
                                {this.state.idpessoaformulario !== null && isGestor &&
                                    <EmpresaPessoaVincularDialog
                                        form={form}
                                        xappRouteParams={xappRouteParams}
                                        onChange={this.handleChangeFormulario}
                                        target={this.props.target}
                                        callback={callback}
                                    />
                                }
                                {this.state.idpessoaformulario !== null &&
                                    <XAPPButton
                                        type="Button"
                                        className="bg-grey-darker hover:bg-grey-darker text-white mr-8"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            acaoRegistro(this.state, { ...xappRouteParams, customTags }, this.state.statusregistro === 0 ? "ATIVAR" : "INATIVAR", callback);
                                            closeDialog();
                                        }}
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={"block"}
                                        label={md.mobile() === null && md.tablet() === null ? (this.state.statusregistro === 0 ? "Ativar" : "Inativar") : ""}
                                    />
                                }
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        save(this.state, { ...xappRouteParams, customTags }, callback);
                                        if (!isButton) {
                                            closeDialog();
                                        }
                                    }}
                                    disabled={!this.canBeSubmitted()}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                />
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                }
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDialog: Actions.closeDialog,
        save: Actions.save,
        get: Actions.get,
        acaoRegistro: Actions.acaoRegistro,
        getTemplate: Actions.getTemplate,
        getPessoaTipo: Actions.getPessoaTipo,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage,
    }, dispatch);
}

function mapStateToProps({ Pessoa, auth }) {
    return {
        formDialog: Pessoa.EmpresaPessoaReducer.formDialog,
        template: Pessoa.EmpresaPessoaReducer.template,
        tipos: Pessoa.EmpresaPessoaReducer.tipos,
        TagsPessoa: Pessoa.TagFuncionalidadeReducer["pessoa"],
        settings: auth.user.data.settings,
    };
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaDialog));
